const container = document.querySelector('.slider-container');
document.querySelector('.slider-next').addEventListener('click', () => {
  container.scrollBy({ left: container.offsetWidth, behavior: 'smooth' });
});
document.querySelector('.slider-prev').addEventListener('click', () => {
  container.scrollBy({ left: -container.offsetWidth, behavior: 'smooth' });
});




function fun_sizeguide(event) {
     var checkbox = event;
  var current_id = checkbox.getAttribute('id');
  var parent_block = $('#'+current_id).parent().parent().parent().parent().parent().parent().parent().parent().parent();
    // Toggle visibility for both sets of divs
    if (checkbox.checked) {
      // Show both 'inches_wrap', Hide both 'centi_wrap'
      let inchesDivs = document.querySelectorAll('#inches_wrap');
      let centiDivs = document.querySelectorAll('#centi_wrap');
      
      inchesDivs.forEach(div => {
        div.style.display = 'block';  // Show the 'inches_wrap'
      });
      
      centiDivs.forEach(div => {
        div.style.display = 'none';  // Hide the 'centi_wrap'
      });
    } else {
      // Show both 'centi_wrap', Hide both 'inches_wrap'
      let inchesDivs = document.querySelectorAll('#inches_wrap');
      let centiDivs = document.querySelectorAll('#centi_wrap');
      
      inchesDivs.forEach(div => {
        div.style.display = 'none';  // Hide the 'inches_wrap'
      });
      
      centiDivs.forEach(div => {
        div.style.display = 'block';  // Show the 'centi_wrap'
      });
    }
}

